"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const errors_1 = require("@/common/errors");
function default_1({ fromUrlParam }) {
    return __awaiter(this, void 0, void 0, function* () {
        return yield (0, api_1.getData)('/room/room_create_check/')
            .then(res => {
            var _a, _b;
            if ((_a = res.data) === null || _a === void 0 ? void 0 : _a.success) {
                return true;
            }
            else {
                const status = (_b = res.data) === null || _b === void 0 ? void 0 : _b.status;
                const memberSettingUrl = `/member/setting?from=/room${fromUrlParam}`;
                switch (status) {
                    case 300:
                        alert(`${i18next_1.default.t('인증 후 이용할 수 있어요')}:)`);
                        window.location.href = memberSettingUrl;
                        break;
                    case 301:
                        alert(`${i18next_1.default.t('만 19세 미만의 미성년자는 법정대리인 동의 후 이용할 수 있어요')}:)`);
                        window.location.href = memberSettingUrl;
                        break;
                    case 302:
                        alert(i18next_1.default.t('운영 정책 위반으로 신규 판매가 중지된 계정이에요. 판매 중지 사유 또는 이의 제기를 원하실 경우 1:1문의하기로 방문해주세요'));
                        window.location.replace('/fondee/qna');
                        break;
                    default:
                        alert((0, errors_1.commonErrorMsg)());
                        (0, functions_1.goToMain)();
                }
                return false;
            }
        })
            .catch(() => {
            alert((0, errors_1.commonErrorMsg)());
            (0, functions_1.goToMain)();
            return false;
        });
    });
}
exports.default = default_1;
